import React, { Component } from 'react';
import { Form, Checkbox, Button, Message, Header } from 'semantic-ui-react';
import { updateInPath } from '../../../../common/utils';
import { getYearsAsStrings, countries, counties, occupations } from '../../../../common/utils/data';
import { validUser } from '../../../../common/utils/inputValidator.js';
import { clone } from 'ramda';
import { withNamespaces } from 'react-i18next';


class Register extends Component {
  constructor(props) {
    super();

    this.state = {
      data: {
        username: '',
        password: '',
        password_check: '',
        attributes: {
          given_name: '',
          family_name: '',
          email: '',
          'custom:occupation': '',
          'custom:occupation_details': '',
          'custom:year_of_birth': '',
          'custom:country_of_residence': '',
          'custom:county_of_residence': '',
          'custom:phone_number': ''
        }
      },
      hasAcceptedPrivacyPolicy: false,
      hideCountyField: true
    };
  }

  updateCountryOfResidence = (e, { name, value }) => {
    if (value !== 'ee') {
      this.setState(prevState => updateInPath(prevState, 'data.attributes.custom:county_of_residence', ''));
    }

    this.setState(prevState => updateInPath(prevState, 'hideCountyField', value !== 'ee' ? true : false));
    this.setState(prevState => updateInPath(prevState, 'data.attributes.custom:country_of_residence', value));
  }

  handleChange = (e, { name, value }) => {
    const val = (name === 'username' ? value.trim().toLowerCase() : value);
    this.setState(prevState => updateInPath(prevState, 'data.' + name, val));
  }

  // TODO terms of conditions
  acceptPrivacyPolicy = (e, {checked}) => {
    this.setState(prevState => updateInPath(prevState, 'hasAcceptedPrivacyPolicy', checked));
  };

  handleSubmit = () => {
    const data = clone(this.state.data);
    delete data.password_check;

    data.attributes.email = data.username;
    this.props.onSubmit(data.username, data.password, data.attributes);
  }

   handleCompletePwd = () => {
    const data = clone(this.state.data);

     delete data.attributes.email;
     this.props.onChangePassword(this.props.success, data.password, data.attributes);
  }

  // TODO: this should be somewhere under common profile data validator
  canSignUp = () => {
    const { username, password, attributes } = this.state.data;
    
    if (!this.state.hasAcceptedPrivacyPolicy) {
      return false;
    } else if (!username && (this.props.success && this.props.success.indexOf('@') === -1) ) {
      console.log('gutt');
      return false;
    } else if (!password) {
      return false;
    } else if (!validUser(attributes)) {
      return false;
    }

    return true;
  }

  passwordsMatch = (pwd1, pwd2) => {
    if (!pwd1.length && !pwd2.length) {
      return true;
    } else if (pwd1 === pwd2) {
      return true;
    }

    return false;
  }

  render() {
    const { username, password, password_check, attributes } = this.state.data;
    const { t, error, success } = this.props;

    const invitation = (success && success.indexOf('@') > -1);
    const pwdMatch = this.passwordsMatch(password, password_check);

    // TODO create a reusable input
    return (
      <Form>
        <Header as='h4' content={t('public:auth.credentials')}/>
        <Form.Group>
          <Form.Input
            disabled={!!invitation}
            width={6}
            required
            label={t('public:auth.email')}
            placeholder={t('public:auth.email_i')}
            name='username'
            value={invitation ? success : username}
            onChange={this.handleChange}
          />
          <Form.Input
            width={5}
            required
            label={t('public:auth.pwd')}
            placeholder={t('public:auth.pwd_i')}
            type='password'
            name='password'
            value={password}
            onChange={this.handleChange}
          />
          <Form.Input
            width={5}
            required
            label={t('public:auth.pwd_check')}
            placeholder={t('public:auth.pwd_check_i')}
            type='password'
            name='password_check'
            value={password_check}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Field>
          {t('public:auth.pwd_comment')}
        </Form.Field>
        <Header as='h4' content={t('public:auth.personal_details')}/>
        <Form.Group>
          <Form.Input
            width={6}
            required
            label={t('public:auth.given_name')}
            placeholder={t('public:auth.given_name_i')}
            name='attributes.given_name'
            value={attributes.given_name}
            onChange={this.handleChange}
          />
          <Form.Input
            width={5}
            required
            label={t('public:auth.family_name')}
            placeholder={t('public:auth.family_name_i')}
            name='attributes.family_name'
            value={attributes.family_name}
            onChange={this.handleChange}
          />
          <Form.Dropdown
            width={5}
            fluid
            search
            selection
            required
            label={t('public:auth.yob')}
            placeholder={t('public:auth.yob_i')}
            name='attributes.custom:year_of_birth'
            //value={attributes['custom:year_of_birth']}
            options= {getYearsAsStrings()}
            onChange={this.handleChange}
          />
        </Form.Group>

        <Form.Group>
          <Form.Input
            width={6}
            required
            label={t('public:auth.phone_number')}
            placeholder={t('public:auth.phone_number_i')}
            name='attributes.custom:phone_number'
            value={attributes['custom:phone_number']}
            onChange={this.handleChange}
          />
        </Form.Group>
        
        <Form.Group>
          <Form.Dropdown
            width={6}
            fluid
            selection
            required
            label={t('public:auth.occ')}
            name='attributes.custom:occupation'
            options={occupations}
            onChange={this.handleChange}
          />
          <Form.Input
            width={10}
            required
            label={t('public:auth.occ_details')}
            placeholder={t('public:auth.occ_details_i')}
            name='attributes.custom:occupation_details'
            value={attributes['custom:occupation_details']}
            onChange={this.handleChange}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Dropdown
            width={6}
            required
            label={t('public:auth.country')}
            fluid
            search
            selection
            name='attributes.custom:country_of_residence'
            options={countries}
            onChange={this.updateCountryOfResidence}
          />
          {
          !this.state.hideCountyField &&
              <Form.Dropdown
                width={10}
                required={!this.state.hideCountyField}
                label={t('public:auth.county')}
                fluid
                search
                selection
                name='attributes.custom:county_of_residence'
                options={counties}
                onChange={this.handleChange}
              />
          }
        </Form.Group>
        <Header as='h4' content={t('public:auth.privacy')}/>
        <Form.Group>
          <Form.Field
            width={6}
            required
            control={Checkbox}
            label={t('public:auth.privacy_accept')}
            name='_acceptedCompetitionRules'
            checked={this.state.hasAcceptedPrivacyPolicy}
            onChange={this.acceptPrivacyPolicy}
          />
          <Form.Field
            width={10}>
            <a
              href='https://robotex.international/privacy-policy/'
              target="_blank"
              rel="noopener noreferrer">
              https://robotex.international/privacy-policy/
            </a>
          </Form.Field>
        </Form.Group>
        {
          !pwdMatch &&
            <Message negative>
              <Message.Header>{t('public:auth.pwd_nomatch')}</Message.Header>
            </Message>
        }
        {
          this.props.error &&
            <Message negative>
              <Message.Header>{t('public:auth.create_account_fail')}</Message.Header>
              <p>{t(`public:auth.ex.${error}`)}</p>
            </Message>
        }
        <Button
          fluid
          disabled={!this.canSignUp() || !pwdMatch}
          positive
          className='rtxAuthFormButton'
          content={t('public:auth.create_account')}
          onClick={invitation? this.handleCompletePwd : this.handleSubmit}
        />
      </Form>
    );
  }
}

export default withNamespaces('public')(Register);



// WEBPACK FOOTER //
// ./src/public/components/Auth/Forms/SignUp.js